import React from "react";
import ComingSoon from '../../components/ComingSoon/ComingSoon';

const Users = () => {
  return <div><ComingSoon /></div>;
};

export default Users;
